var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnackbarSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.5 12.875L10.5 15.875L16.5 9.875M7.8 21.875H16.2C17.8802 21.875 18.7202 21.875 19.362 21.548C19.9265 21.2604 20.3854 20.8015 20.673 20.237C21 19.5952 21 18.7552 21 17.075V8.675C21 6.99484 21 6.15476 20.673 5.51303C20.3854 4.94854 19.9265 4.4896 19.362 4.20198C18.7202 3.875 17.8802 3.875 16.2 3.875H7.8C6.11984 3.875 5.27976 3.875 4.63803 4.20198C4.07354 4.4896 3.6146 4.94854 3.32698 5.51303C3 6.15476 3 6.99484 3 8.675V17.075C3 18.7552 3 19.5952 3.32698 20.237C3.6146 20.8015 4.07354 21.2604 4.63803 21.548C5.27976 21.875 6.11984 21.875 7.8 21.875Z",
    stroke: "#16A763",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackbarSuccess);
export default __webpack_public_path__ + "static/media/SnackbarSuccess.83076ff4d87bc4d784887db4caab83bc.svg";
export { ForwardRef as ReactComponent };